import * as ApiManager from './_manager';
import store from '@/store';

export const chatRoom = {
    checkMemberExistence: (payload) => {
        return ApiManager.callApi(`/guest/company/${store.getters['company/getCurrentCompanyId']}/chat-room/${payload.chat_room_id}/members/check-member-existence`, payload);
    },
    registerMember: (payload) => {
        return ApiManager.callApi(`/guest/company/${store.getters['company/getCurrentCompanyId']}/chat-room/${payload.chat_room_id}/members/register`, payload);
    },
    updateMember: (payload) => {
        return ApiManager.callApi(`/guest/company/${store.getters['company/getCurrentCompanyId']}/chat-room/${payload.chat_room_id}/members/update-profile/${payload.id}`, payload);
    },
    checkMemberExistenceBasedOnToken: (payload) => {
        return ApiManager.callApi(`/guest/company/${store.getters['company/getCurrentCompanyId']}/chat-room/check-member-existence`, payload);
    },
    autoRegisterMember: (payload) => {
        return ApiManager.callApi(`/guest/company/${store.getters['company/getCurrentCompanyId']}/chat-room/auto-register`, payload);
    },
}